import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import LogdevTable, { getRows } from "./LogdevTable";
import {
  intervalSelector,
  tableDataSelector,
  tableDatesSelector,
} from "../../../selectors/logdevsSelectors";
import { orgIdSelector } from "../../../selectors/orgIdSelector";
import { receiveDateRange as receiveDateRangeHost } from "../../../redux/actions/Host";
import { receiveDateRange as receiveDateRangeIp } from "../../../redux/actions/Ip";
import { pageWithPayloadAndQuery } from "../../../redux/actions/Page";

/*
Component
*/

const LogdevTableContainer = (props) => {
  const {
    data,
    gotoHost,
    gotoIp,
    gotoSensor,
    orgId,
    selectedInterval,
    windowEnd,
    windowStart,
  } = props;

  const onClickHost = (hostId) => (evt) => {
    evt.stopPropagation();

    gotoHost({ hostId, orgId, selectedInterval });
  };

  const onClickIp = (ipId) => (evt) => {
    evt.stopPropagation();

    gotoIp({ ipId, orgId, selectedInterval });
  };

  const onClickSensor = (sensorId) => (evt) => {
    evt.stopPropagation();

    gotoSensor({ sensorId, orgId });
  };

  const rows = getRows({
    data,
    onClickHost,
    onClickIp,
    onClickSensor,
  });

  return (
    <LogdevTable
      rows={rows}
      dateEnd={windowEnd}
      windowEnd={windowEnd}
      windowStart={windowStart}
    />
  );
};

LogdevTableContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  gotoHost: PropTypes.func.isRequired,
  gotoIp: PropTypes.func.isRequired,
  gotoSensor: PropTypes.func.isRequired,
  orgId: PropTypes.string.isRequired,
  selectedInterval: PropTypes.shape({}).isRequired,
  windowEnd: PropTypes.string.isRequired,
  windowStart: PropTypes.string.isRequired,
};

LogdevTableContainer.defaultProps = {
  data: [],
};

const mapStateToProps = (state) => {
  const data = tableDataSelector(state);
  const orgId = orgIdSelector(state);

  const selectedInterval = intervalSelector(state);
  const { windowEnd = "", windowStart = "" } = tableDatesSelector(state);

  return {
    data,
    orgId,
    selectedInterval,
    windowEnd,
    windowStart,
  };
};

const mapDispatchToProps = (dispatch) => ({
  gotoHost: ({ hostId, orgId, selectedInterval }) => {
    const payload = {
      orgId,
      toplevel: "investigate",
      secondlevel: "hostnames",
      id1: hostId,
    };

    const { dateRange = {} } = selectedInterval;

    dispatch(
      receiveDateRangeHost({
        dateRange,
        insertId: hostId,
      })
    );

    dispatch(
      pageWithPayloadAndQuery({
        payload,
        query: {},
      })
    );
  },
  gotoIp: ({ ipId, orgId, selectedInterval }) => {
    const payload = {
      orgId,
      toplevel: "investigate",
      secondlevel: "ips",
      id1: ipId,
    };

    const { dateRange = {} } = selectedInterval;

    dispatch(
      receiveDateRangeIp({
        dateRange,
        insertId: ipId,
      })
    );

    dispatch(
      pageWithPayloadAndQuery({
        payload,
        query: {},
      })
    );
  },
  gotoSensor: ({ sensorId, orgId }) => {
    const payload = {
      orgId,
      toplevel: "settings",
      secondlevel: "sensors",
      id1: sensorId,
    };

    dispatch(
      pageWithPayloadAndQuery({
        payload,
        query: {},
      })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogdevTableContainer);
